import emerasLogo from './app/assets/images/logo-emeras.png';
import a4MobilityLogo from './app/assets/images/logo-a4bspd.png';
import satapLogo from './app/assets/images/logo-satap.png';
import brebemiLogo from './app/assets/images/logo-brebemi.png';
import cinquetLogo from './app/assets/images/logo-5t.png';
import cinquetLogoDark from './app/assets/images/logo-5t-dark.png';
import { AppTheme } from '_store/application/types';

const localStorageKey = process.env.LOCAL_STORAGE_KEY;

export const updateLocalStorage = (field: string, value: any) => {
  try {
    const storedObject = JSON.parse(localStorage.getItem(localStorageKey) || '{}');
    storedObject[field] = value;
    localStorage.setItem(localStorageKey, JSON.stringify(storedObject));
  } catch (error) {
    console.error(`Error updating localStorage for field ${field}:`, error);
  }
};

export const removeFromLocalStorage = (field: string) => {
  try {
    const storedObject = JSON.parse(localStorage.getItem(localStorageKey) || '{}');
    if (storedObject[field] !== undefined) {
      delete storedObject[field];
      localStorage.setItem(localStorageKey, JSON.stringify(storedObject));
    }
  } catch (error) {
    console.error(`Error removing ${field} from localStorage:`, error);
  }
};

export const getFromLocalStorage = (field: string) => {
  try {
    const storedObject = JSON.parse(localStorage.getItem(localStorageKey) || '{}');
    return storedObject[field];
  } catch (error) {
    console.error(`Error reading ${field} from localStorage:`, error);
    return null;
  }
};

export interface Client {
  name: string;
  logoPath: string;
  url?: string;
}

export const getAppEnvironmentLabel = (): string => {
  const appEnv = process.env.APP_ENV?.trim();
  if (appEnv) {
    return appEnv;
  }

  const apiEndpoint = process.env.API_ENDPOINT || '';

  if (/localhost|127\.0\.0\.1/i.test(apiEndpoint)) {
    return 'Local';
  }
  if (/\.dev\./i.test(apiEndpoint)) {
    return 'Development';
  }
  if (/\.staging\./i.test(apiEndpoint)) {
    return 'Staging';
  }
  if (/\.demo\./i.test(apiEndpoint)) {
    return 'Demo';
  }
  if (/\.prod\./i.test(apiEndpoint)) {
    return 'Production';
  }

  return 'Unknown';
};

export const isAppProduction = (): boolean => {
  const label = getAppEnvironmentLabel().trim().toLowerCase();
  return label === 'production' || label === 'prod';
};

export const mapClient = (client: string): Client => {
  const currentTheme = getFromLocalStorage('appTheme');

  switch (client) {
    case 'a4mobility':
      return {
        name: 'A4 Mobility',
        logoPath: a4MobilityLogo,
      };
    case 'satap':
      return {
        name: 'SATAP',
        logoPath: satapLogo,
      };
    case 'brebemi':
      return {
        name: 'Brebemi',
        logoPath: brebemiLogo,
      };
    case '5t':
      return {
        name: '5t',
        logoPath: currentTheme === AppTheme.DARK ? cinquetLogoDark : cinquetLogo,
      };
    default:
      return {
        name: 'Emeras',
        logoPath: emerasLogo,
      };
  }
};
